import { lazy } from "react";
import Loadable from "../../../../../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../../../../../router/AuthorizedRoute";
import { MODULE_IDS } from "../../../../../../constants/enums";
import { BUSINESS_ALL_TASKS } from "../Business.constants";


const BusinessAllTasks = Loadable(
  lazy(() =>
    import(
      "../BusinessPolicyNotes/BusinessActivitiesTabs"
    ).then(({ BusinessActivitiesTabs }) => ({
      default: BusinessActivitiesTabs,
    }))
  )
);
export const AllTasksRoutes = [
  
          {
            path: `${BUSINESS_ALL_TASKS}`,
            exact: true,
            element: (
              <AuthorizedRoute moduleKeys={[MODULE_IDS.BUSINESS_POLICY]}>
                <BusinessAllTasks />
              </AuthorizedRoute>
            ),
          },
];
